"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var to_string_1 = require("./to-string");

var lowerCase = function lowerCase(str) {
  return to_string_1.default(str).toLowerCase();
};

exports.default = lowerCase;